
// main fullpage render
function mainFullpageInit(preloader, fastLoad=false) {

  var mainAnchorsArray = ['main', 'cases'];

  $('.left-menu__item').each(function(index, el) {
    var linkName = $(this).attr('data-link-name');
    mainAnchorsArray.push(linkName);
  });

  // scrollbar show or not
  if ($windowWidth <= $breakPointBpMd) {
    $mainOptionScrollbar = true;
  } else {
    $mainOptionScrollbar = false;
  }

  var mainFullpage = new fullpage('#fullpage-main', {
  // $('#fullpage-main').fullpage({
    licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
    //Navigation
    menu: '#my-circle-menu',
    lockAnchors: false,
    anchors: mainAnchorsArray,
    navigation: false,
    navigationPosition: 'right',
    navigationTooltips: [],
    showActiveTooltip: false,
    slidesNavigation: false,
    slidesNavPosition: 'bottom',

    //Scroll
    css3: true,
    scrollingSpeed: 800,
    autoScrolling: true,
    fitToSection: true,
    fitToSectionDelay: 1000,
    scrollBar: $mainOptionScrollbar,
    easing: 'easeInOutCubic',
    easingcss3: 'ease',
    loopBottom: false,
    loopTop: false,
    loopHorizontal: true,
    continuousVertical: false,
    continuousHorizontal: false,
    scrollHorizontally: false,
    interlockedSlides: false,
    dragAndMove: false,
    offsetSections: false,
    resetSliders: false,
    fadingEffect: false,
    normalScrollElements: '#element1, .element2',
    scrollOverflow: false,
    scrollOverflowReset: false,
    scrollOverflowOptions: null,
    touchSensitivity: 5,
    normalScrollElementTouchThreshold: 5,
    bigSectionsDestination: null,

    //Access
    keyboardScrolling: false,
    animateAnchor: true,
    recordHistory: false,

    //Design
    controlArrows: true,
    verticalCentered: true,
    sectionsColor : [],
    paddingTop: '0',
    paddingBottom: '0',
    fixedElements: '#header, .footer',
    responsiveWidth: 0,
    responsiveHeight: 0,
    responsiveSlides: false,
    parallax: false,
    parallaxOptions: {type: 'reveal', percentage: 62, property: 'translate'},

    //Selectors
    sectionSelector: '.section',
    slideSelector: '.slide',

    lazyLoading: false,

    //Events
    onLeave: function(origin, destination, direction){
      // console.log('section : leave from : ' + origin.index + ' to ' + destination.index);

      // console.log('_main-case-mobile-image', destination.item);
      // console.log('_main-case-mobile-image', destination.anchor);




      if (destination.index == 0) {
        // defaults : videoFadeIn=true, firstLoad=false, killPreload=false
        if ($windowWidth > $breakPointBpMd) {
          mainVideobgStart(false, false, false);
        }
        else {
          var vid = document.getElementById("mobile-page-videobg-main");
          vid.play();
        }

        // mobile video handler
        // if ($windowWidth <= $breakPointBpMd) {
        //   mainVideobgMobile();
        // }
      }
      if (destination.index == 1) {

        if ($windowWidth > $breakPointBpMd) {
          casesVideobgStart(
            false,
            window.caseVideosArray[$showVideo][0],
            window.caseVideosArray[$showVideo][1],
            window.caseVideosArray[$showVideo][2]
          );
        }

        if ($windowWidth <= $breakPointBpMd) {
          caseMobileVideoStart(window.caseMobileVideos[$showVideoMobile][1]);
        }
      }

      // left menu appear and cases footer link handler
      $footerCasesLink  = $('.main-footer__link');
      $footerPlusButton = $('.fullpage-link._plus');
      var bottomPlusId  = $('#bottom-plus');
      if ((destination.index < 2) || (destination.index < 2 && $leftMenu.hasClass('active'))) {
        leftMenuHide();
        // bottomPlusHide();
        if (!$footerCasesLink.hasClass('active')) {
          $footerPlusButton.fadeOut(300, function() {
            $footerCasesLink.addClass('active');
            $footerCasesLink.fadeIn(300, function() {});
          });
        }
      } else {
        leftMenuShow();
        // bottomPlusShow();
        if ($footerCasesLink.hasClass('active')) {
          $footerCasesLink.fadeOut(300, function() {
            $footerCasesLink.removeClass('active');
            $footerPlusButton.fadeIn(300, function() {});
          });
        }
      }

      // left menu scroll handler
      var activeSection = $('[data-position="2"]').attr('data-link-number');
      // console.log('activeSection = ' + activeSection);
      if (destination.index > 1 && destination.index != activeSection ) {
        leftMenuScrollHandler(direction);
      }

      // left menu two steps detect and handle it
      var onLeaveStep = destination.index - origin.index;
      // console.log('onLeaveStep = ' + onLeaveStep);
      if (onLeaveStep == 2) {
        leftMenuStepsMove(0, 1);
      } else if (onLeaveStep == -2) {
        leftMenuStepsMove(1, 0);
      }

      // animation handler
      mainAnimationBgrHandler(origin.index, destination.index);

      // main page last screen about us handler
      var bottomPlusId      = $('#bottom-plus');
      var bottomPlusLink    = $('#bottom-plus .fullpage-link._plus');
      var aboutUsSingleLink = $('.about-us-link');
      if (destination.isLast) {
        if (!bottomPlusId.hasClass('_about-linked')) {
          bottomPlusId.addClass('_about-linked');
          bottomPlusLink.fadeOut(300, function() {
            aboutUsSingleLink.fadeIn(300, function() {});
          });
        }
      } else {
        if (bottomPlusId.hasClass('_about-linked')) {
          bottomPlusId.removeClass('_about-linked');
          aboutUsSingleLink.fadeOut(300, function() {
            bottomPlusLink.fadeIn(300, function() {});
          });
        }
      }
    },
    afterLoad: function(origin, destination, direction){
      // console.log('section : loaded : ' + destination.anchor);
      leftMenuSetActiveItem();

      // if (!$('.mobile-page-videobg-main video').hasClass('_start')) {
      // if ($windowWidth <= $breakPointBpMd) {
      //   mainVideobgMobile();
        // setTimeout(function(){
        //   $('#preloader').fadeOut(300);
        // },2000);
      // }

      var menuCasesItem = $('.menu-top-fixed__cases');
      if (destination.index != 0 && !menuCasesItem.hasClass('active')) {
        menuCasesItem.addClass('active');
      } else if (destination.index == 0 && menuCasesItem.hasClass('active')) {
        menuCasesItem.removeClass('active');
      }

      // kill preloader after cases hash loaded
      if (fastLoad && destination.anchor == 'cases') {
        $('#preloader').fadeOut(300);
      } else if (fastLoad && destination.anchor == 'main' && !$('.main-videobg').hasClass('start')) {
        // defaults : videoFadeIn=true, firstLoad=false, killPreload=false
        mainVideobgStart(true, false, true);
      }
    },
    afterRender: function(){
      // console.log('fullpage : rendered');

      $myScroll = new IScroll('#fullpage-main', {
        scrollbars: true,
        mouseWheel: true,
        interactiveScrollbars: true,
        shrinkScrollbars: 'scale',
      });
      console.dir($myScroll.options);

      // MOBILE VIDEO HANDLER
      if ($windowWidth <= $breakPointBpMd) {
        // mobile cookie video handler
        if ($.cookie('cases-counter-mobile') == undefined || parseInt($.cookie('cases-counter-mobile')) >= window.caseMobileVideos.length - 1) {
          $.cookie('cases-counter-mobile', 0);
        } else {
          var temp = parseInt($.cookie('cases-counter-mobile'));
          $.cookie('cases-counter-mobile', temp + 1);
        }
        $showVideoMobile = parseInt($.cookie('cases-counter-mobile'));
      }

      // prepare cases video to run
      if ($windowWidth <= $breakPointBpMd) {
        caseMobileVideoStart(window.caseMobileVideos[$showVideoMobile][1], pause=true);

      }

      // second screen video cookie handler & async loading DESKTOP
      // cookie video handler
      if ($.cookie('cases-counter') == undefined || parseInt($.cookie('cases-counter')) >= window.caseVideosArray.length - 1) {
        $.cookie('cases-counter', 0);
      } else {
        var temp = parseInt($.cookie('cases-counter'));
        $.cookie('cases-counter', temp + 1);
      }
      $showVideo = parseInt($.cookie('cases-counter'));
      casesVideobgStart(
        false,
        window.caseVideosArray[$showVideo][0],
        window.caseVideosArray[$showVideo][1],
        window.caseVideosArray[$showVideo][2]
      );

      // cookie second visit handler

      if (preloader) {
        if (fastLoad) {
          // $('#preloader').fadeOut(300);
          preloaderHandler(true);
        } else {
          // $('#preloader').fadeOut(300);
          // defaults : videoFadeIn=true, firstLoad=false, killPreload=false
          mainVideobgStart(true, true, false);
          // preloaderHandler();
        }
      } else {
        var activeSection = parseInt($('.left-menu__item.active').attr('data-link-number'));
        // console.log('GOING TO SECTION = ' + activeSection);
        leftMenuShow();
        if (activeSection != 2) {
          leftMenuStepsMove(1, 0);
        } else {
          leftMenuStepsMove(2, 0);
        }
        fullpage_api.moveTo(activeSection + 1);
        setTimeout(function() {
          $('#preloader').fadeOut(400);
        }, 700);
      }
    },
    afterResize: function(){},
    afterResponsive: function(isResponsive){},
    afterSlideLoad: function(section, origin, destination, direction){},
    onSlideLeave: function(section, origin, destination, direction){}
  });

}


// case render 
function caseFullpageInit(caseItem, destroy=true) {

  if (destroy) {
    fullpage_api.destroy('all');
  }

  $caseItemCurrent = caseItem;
  // console.log('$caseItemCurrent', $caseItemCurrent);

  var anchorsArray = ['home'];

  $('#' + $caseItemCurrent + ' .section').each(function(index, el) {
    if (index > 0) {
      anchorsArray.push('page-' + index);
    }
  });

  // console.log(anchorsArray);

  // scrollbar show or not
  if ($windowWidth <= $breakPointBpMd) {
    $mainOptionScrollbar = true;
  } else {
    $mainOptionScrollbar = false;
  }

  var caseFullpage = new fullpage('#' + $caseItemCurrent, {
  // $('#' + $caseItemCurrent).fullpage({
    licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
    //Navigation
    menu: '#' + caseItem + '-menu',
    lockAnchors: true,
    anchors: anchorsArray,
    navigation: false,
    navigationPosition: 'right',
    navigationTooltips: [],
    showActiveTooltip: false,
    slidesNavigation: false,
    slidesNavPosition: 'bottom',

    //Scroll
    css3: true,
    scrollingSpeed: 700,
    autoScrolling: true,
    fitToSection: true,
    fitToSectionDelay: 300,
    scrollBar: false,
    // scrollBar: $mainOptionScrollbar,
    easing: 'easeInOutCubic',
    easingcss3: 'ease',
    loopBottom: false,
    loopTop: false,
    loopHorizontal: true,
    continuousVertical: false,
    continuousHorizontal: false,
    scrollHorizontally: false,
    interlockedSlides: false,
    dragAndMove: false,
    offsetSections: false,
    resetSliders: false,
    fadingEffect: false,
    // normalScrollElements: '.mobile-normal-scroll',
    normalScrollElements: '',
    scrollOverflow: false,
    scrollOverflowReset: false,
    scrollOverflowOptions: null,
    touchSensitivity: 15,
    bigSectionsDestination: null,

    //Access
    keyboardScrolling: false,
    animateAnchor: true,
    recordHistory: false,

    //Design
    controlArrows: true,
    verticalCentered: true,
    sectionsColor : [],
    paddingTop: '0',
    paddingBottom: '0',
    fixedElements: '#header, .footer',
    responsiveWidth: 0,
    responsiveHeight: 0,
    responsiveSlides: false,
    parallax: false,
    // parallaxOptions: {type: 'reveal', percentage: 62, property: 'translate'},

    //Selectors
    sectionSelector: '.section',
    slideSelector: '.slide',

    lazyLoading: false,

    //Events
    onLeave: function(origin, destination, direction){
      if (destination.index == 0) {
        return false;
      }
      // console.log('case-section : leave : destination.index = ' + destination.index);
      // console.log('caseItemCurrent = ' + $caseItemCurrent);
      caseAnimationHandler($caseItemCurrent, origin.index, destination.index);
      caseMenuInheritanceHandler($caseItemCurrent, destination.index);

      // appear and disappear last section button handler
      caseContactUsHandler(destination);
    },
    afterLoad: function(origin, destination, direction){
      // console.log('case-section : loaded');

      caseLastScreenScrollHandler(destination);
      
      if (!destroy) {
        fullpage_api.setMouseWheelScrolling(true);
        fullpage_api.setAllowScrolling(true);
      }

      
      if ($windowWidth <= $breakPointBpMd) {
        var fullImage   = $(destination.item).find('.type__image_full').length;
        var fixedLeft   = $('.case-menu-fixed .case-menu-fixed__left');
        var fixedClose  = $('.case-menu-fixed .case-menu-fixed__close');
        var fixedSocial = $('.case-menu-fixed .footer-social__wrapper');
        if (destination.index == 0 || fullImage == 1) {
          if (!fixedLeft.hasClass('_hidden')) {
            fixedLeft.addClass('_hidden');
          }
          if (!fixedClose.hasClass('_hidden')) {
            fixedClose.addClass('_hidden');
          }
          if (!fixedSocial.hasClass('_hidden')) {
            fixedSocial.addClass('_hidden');
          }
        } else {
          fixedLeft.removeClass('_hidden');
          fixedClose.removeClass('_hidden');
          fixedSocial.removeClass('_hidden');
        }
      } 

    },
    afterRender: function(){
      // console.log('case : rendered'); 


      $(function(){
        $.lazyLoadXT.scrollContainer = '#' + $caseItemCurrent;
        $.extend($.lazyLoadXT, {
          // edgeY: 1000,
          srcAttr: 'data-src',
          forceLoad: true,
          visibleOnly: false,
          oninit: function(){
            // console.log('oninit : lazyLoadXT');
          },
          onshow: function(){
            // console.log('onshow : lazyLoadXT');
          },
          onload: function(){
            // console.log('onload : lazyLoadXT');
          },
          onerror: function(){
            // console.log('onerror : lazyLoadXT');
          },
        });
      });

      // $(window).lazyLoadXT();

      // $('#' + $caseItemCurrent).lazyLoadXT({
      //   // edgeY: 1000,
      //   srcAttr: 'data-src',
      //   forceLoad: true,
      //   visibleOnly: false,

      // });



      $('.fp-completely.fp-section.active .case-section__title').css('display', 'block');
      $('.left-menu__item.active').css('display', 'none').removeClass('_translate-xy');

      if (destroy) {
        $leftMenu.hide(0);

        // console.log('$caseItemCurrent', $caseItemCurrent);

        $('#' + $caseItemCurrent).unbind('swipedown').on('swipedown',function(){
          fullpage_api.moveSectionUp();
        });
        $('#' + $caseItemCurrent).unbind('swipeup').on('swipeup',function(){
          fullpage_api.moveSectionDown();
        });

      }

      if (!destroy) {
        $('.main-footer').removeClass('_shown');
        bottomPlusHide();
        // hide top menu
        $menuTopMain.animate({top : '-10%'}, {
          duration: 100,
          specialEasing: {
            top: "easeOutCubic"
          },
          complete: function() {
            setTimeout(function(){
              $('#preloader').removeClass('active').fadeOut(300);
            }, 500)
            fullpage_api.reBuild();
            fullpage_api.setMouseWheelScrolling(true);
            fullpage_api.setAllowScrolling(true);
          }
        });
        // hide fixed logo NFM
        $preloadLogo.animate({top : '-10%'}, {
          duration: 100,
          specialEasing: {
            top: "easeOutCubic"
          },
          complete: function() {}
        });
      }

      caseMainPageHandler($caseItemCurrent);

      caseMenuItemLinkHandler($caseItemCurrent);






    },
    afterResize: function(){},
    afterResponsive: function(isResponsive){},
    afterSlideLoad: function(section, origin, destination, direction){},
    onSlideLeave: function(section, origin, destination, direction){}
  });
}


function caseMenuItemLinkHandler(caseItem) {
  var caseMenuItem = $('#' + caseItem + '-menu a');
  caseMenuItem.unbind().click(function(event) {
    event.preventDefault();
    var pageNumber = parseInt($(this).attr('href').split('-')[1]);
    fullpage_api.moveTo(pageNumber + 1);
  });
}


function caseContactUsHandler(destination) {
  // if ($windowWidth > $breakPointXl) {
  var caseContactsLinkBottom = -200;
  // } else if ($windowWidth <= $breakPointXl) {
    // var caseContactsLinkBottom = -100;
  // }
  if (destination.isLast) {

    var caseBottomLink     = $('#case-contacts-link a');
    var caseBottomLinkText = $('#case-contacts-link span');

    var caseSlug     = $('.fullpage-case.active').attr('data-case-slug');
    var currentCase  = $('[data-link-name="' + caseSlug + '"]');

    var nextCase     = currentCase.next();
    var nextCaseLink = nextCase.attr('data-link-name');
    var nextCaseName = nextCase.text();

    if (nextCaseLink != undefined) {
      caseBottomLink.attr('href', '/#' + nextCaseLink);
      caseBottomLinkText.text(nextCaseName);

      caseBottomLink.unbind().click(function(event) {
        window.location.hash = '#' + nextCaseLink;
        location.reload(true);
        // window.location = '/#' + nextCaseLink;
      });
    } else {
      caseBottomLink.attr('href', '/about-us');
      caseBottomLinkText.text('about us');
    }

    // console.log('nextCaseLink = ' + nextCaseLink);

    $('#case-contacts-link').animate({bottom: 0}, {
      duration: 600,
      queue: false,
      specialEasing: {
        bottom: "easeOutCubic"
      },
      complete: function() {}
    });

  } else {

    $('#case-contacts-link').animate({bottom: caseContactsLinkBottom}, {
      duration: 600,
      queue: false,
      specialEasing: {
        bottom: "easeOutCubic"
      },
      complete: function() {}
    });

  }
}

// open case fullpage and scroll to second section after render
function caseMainPageHandler(caseItem) {
  $windowWidth = $(window).width();

  if ($windowWidth > $breakPointBpSm) {
    fullpage_api.setAllowScrolling(false);
    setTimeout(function() {
      $('.case-menu-fixed').addClass('active');
      $('#' + caseItem + '-menu').addClass('active');
      // console.log('case-menu-fixed : shown');
      fullpage_api.setAllowScrolling(true, 'down, right');
      fullpage_api.moveSectionDown();
    }, 1500);
  } else {
    setTimeout(function() {
      $('.case-menu-fixed').addClass('active');
      $('#' + caseItem + '-menu').addClass('active');
      // console.log('case-menu-fixed : shown');
      if ($('#preloader').hasClass('active')) {
        $('#preloader').fadeOut(300, function() {
          $('#preloader').removeClass('active');
        });
      }
    }, 1000);
  }
}


function caseAnimationHandler(caseItem, index, nextIndex) {

  console.log('caseItem :: ', caseItem);
  if ($windowWidth >= $breakPointBpMd) {
    setTimeout(function() {
      var thisSection = $('#' + caseItem + ' .section').eq(index);
      thisSection.find('.animated-item').each(function(index, el) {
        var animation = $(this).attr('data-animation');
        $(this).removeClass(animation);
      });
    }, 600);
    var nextSection = $('#' + caseItem + ' .section').eq(nextIndex);
    nextSection.find('.animated-item').each(function(index, el) {
      var animation = $(this).attr('data-animation');
      $(this).removeClass(animation).addClass(animation);
    });
  }
}


// main fullpage animation handler
function mainAnimationBgrHandler(index, nextIndex) {
  setTimeout(function() {
    var thisSection = $('#fullpage-main .section').eq(index);
    thisSection.find('.animated-item').each(function(index, el) {
      var animation = $(this).attr('data-animation');
      $(this).removeClass(animation);
    });
  }, 200);
  var nextSection = $('#fullpage-main .section').eq(nextIndex);
  nextSection.find('.animated-item').each(function(index, el) {
    var animation = $(this).attr('data-animation');
    $(this).removeClass(animation).addClass(animation);
  });
}

// single case navigation inheritance handler
function caseMenuInheritanceHandler(caseItem, nextIndex) {
  var caseMenuLink       = $('#' + caseItem + '-menu' + ' .link-' + nextIndex);
  var caseMenuItems      = $('.fullpage-case-single-menu__item');
  var caseMenuLinkParent = caseMenuLink.parent().parent();

  // console.log(caseMenuLinkParent);

  if (caseMenuLinkParent.hasClass('fullpage-case-single-menu__item') && !caseMenuLinkParent.hasClass('_wrapper-active')) {
    caseMenuItems.removeClass('_wrapper-active');
    caseMenuLinkParent.addClass('_wrapper-active');
  } else if (!caseMenuLinkParent.hasClass('fullpage-case-single-menu__item')) {
    $('#' + caseItem + '-menu' + ' .fullpage-case-single-menu__item').removeClass('_wrapper-active');
  }
}

function pageBottomButtonHandler(destination) {
  if (destination.isLast) {
    $('#bottom-plus-about .button-plus').addClass('d-flex')
    $('#bottom-plus-about .button-arrow').addClass('d-none');
  } else {
    $('#bottom-plus-about .button-plus').removeClass('d-flex')
    $('#bottom-plus-about .button-arrow').removeClass('d-none');
  }
}

function pageSingleVideobgHandler(linkWebm, linkMp4="", videoPoster="") {
  $windowWidth = $(window).width();
  $breakPointBpMd  = 767;
  // $breakPointBpMd  = 0;
  if ($windowWidth > $breakPointBpMd) { 
    $pageVideo = $('.page-videobg');
    $pageText  = $('.lite-section__container._video-layer');

    if (!$pageVideo.hasClass('start')) {
      $pageVideo.vide({
        mp4: linkMp4,
        webm: linkWebm,
        // ogv: linkOgv,
        poster: videoPoster,
      }, {
        volume: 1,
        playbackRate: 1,
        muted: true,
        loop: false,
        autoplay: true,
        position: '50% 50%', // Similar to the CSS `background-position` property.
        posterType: 'jpg', // Poster image type. "detect" — auto-detection; "none" — no poster; "jpg", "png", "gif",... - extensions.
        resizing: true, // Auto-resizing, read: https://github.com/VodkaBears/Vide#resizing
        bgColor: 'transparent', // Allow custom background-color for Vide div,
        className: 'single-page-video-class' // Add custom CSS class to Vide div
      });


      var videVideo = $pageVideo.data('vide').getVideoObject();
      videVideo.load();
      videVideo.addEventListener('canplay', function() {
        videVideo.play();
        $('#preloader').fadeOut(300);
        setTimeout(function() {
          $pageText.addClass('active');
        }, 3000);
      }, false);
      $pageVideo.addClass('start');
      $('.single-page-video-class video').attr('playinline', '');
    } else {
      var videVideo = $pageVideo.data('vide').getVideoObject();
      videVideo.play();
      if (!$pageText.hasClass('active')) {
        $pageText.addClass('active');
      }
    }
  } 
  else {
    $pageText  = $('.lite-section__container._video-layer');
    setTimeout(function() {
      $('#preloader').fadeOut(300);
      setTimeout(function() {
        $pageText.addClass('active');
      }, 1000);
    }, 1000);
  }
}


function playVideoMobile(videoUrl) {
  $('.mobile-page-videobg video').each(function(i, video) {
    $(this).attr('src', videoUrl);
    var $vid = $(video);
    var vid = $vid[0];
    vid.load();
    vid.play();
  });
}
jQuery(document).ready(function($) {
  

  mobileMenuHandler();
  mobileCaseMenuHandler();

  
  if ($('#fullpage-main').length) {

    // if (window.location.hash != '#main') {
    //   if (window.location.hash == '#cases') {
    //     window.location.hash == '#cases';
    //   } else {
        // window.location.hash = '#main';
    //   }
    // }

    $windowWidth     = $(window).width();
    $breakPointXl    = 2560;
    $breakPointLg    = 1440;
    $breakPointBpXl  = 1199;
    $breakPointBpLg  = 991;
    $breakPointBpMd  = 768;
    $breakPointBpSm  = 575;

    $preloadPercent  = $('.main-preload-percent');
    $preloadPercentX = $('.main-preload-percent span');
    $preloadLogo     = $('.main-preload-logo');
    $preloadNfm      = $('.image-preload__nfm');
    $preloadDymun    = $('.image-preload__dymun');
    $preloadPlus     = $('.image-preload__plus');
    $preloadText     = $('.main-preload-random-text');
    $preloadCalc     = $('.main-preload-random-calc');
    $preloadAfter    = $('.main-preload-random-after');
    $preloadCalcX    = $('.main-preload-random-calc span');

    $menuTopMain     = $('.menu-top-fixed');

    $leftMenu        = $('#left-menu');

    $bottomPlus      = $('#bottom-plus');

    if (window.location.hash != '#main'  && window.location.hash != '#cases') {
      var hash    = window.location.hash.substr(1);
      var caseObj = $('[data-link-name="' + hash + '"]');

      var getUrl = window.location;
      var baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];

      if (hash == 'archive_cases') {
        window.location.replace(baseUrl + 'archive-cases/');
      } else {
        if (caseObj.length) {
          $caseItem = 'fullpage-case-' + hash;
          // case fixed header data fill
          caseHeaderDataHandle($caseItem);
          $('#' + $caseItem).addClass('active');
          $('#fullpage-main').css('display', 'none');
          preloaderHandler(true, false);
          // caseFullpageInit($caseItem, false);
          $('#preloader').addClass('active');

        } else {
          window.location.hash = '#main';
        }
      }
      
      
    }

    // if (window.location.hash == '#archive_cases') {
    //   window.location.hash = 'main';
    //   location.reload();
    //   mainFullpageInit(true, true);
    //   console.log('ssssssssss');
    // }


    if ($.cookie('first-visit') == undefined && window.location.hash == '#main') {
      mainFullpageInit(true, false);
      $.cookie('first-visit', '1', { expires: 1 });
      // console.log('mainFullpageInit(true, false)');
    } else if ($.cookie('first-visit') == '1' && window.location.hash == '#main') {
      mainFullpageInit(true, true);
      // console.log('mainFullpageInit(true, true)');
    }

    // console.log($.cookie());

    if (window.location.hash == '#cases') {
      mainFullpageInit(true, true);
      // console.log('mainFullpageInit(true, true)');
    } else {
      // mainFullpageInit(true);
    }

    if (window.location.hash == '#main' || window.location.hash == '#cases') {
      fullpage_api.reBuild();
      fullpage_api.setMouseWheelScrolling(false);
      fullpage_api.setAllowScrolling(false);
      fullpage_api.setRecordHistory(false);
    }

  }


  $('.js-case-read-more').click(function(event) {
    $(this).modal({
      fadeDuration: 250
    });
    return false;
  });

});

function preloaderHandler(faster=false, afterpreload=true) {
  var animateSpeed1 = ((faster) ? 2 : 2000);
  var animateSpeed2 = ((faster) ? 2 : 1000);
  var animateSpeed3 = ((faster) ? 2 : 300);

  if ($windowWidth > $breakPointBpSm) {
    var preloadNfm_left = '33.263%';
  } else if ($windowWidth <= $breakPointBpSm) {
    var preloadNfm_left = '24.263%';
  }
  $preloadNfm.animate({left: preloadNfm_left}, {
    duration: animateSpeed1,
    specialEasing: {
      left: "easeOutCubic"
    },
    complete: function() {}
  });

  if ($windowWidth > $breakPointBpSm) {
    var preloadDymun_right = '26.284%';
  } else if ($windowWidth <= $breakPointBpSm) {
    var preloadDymun_right = '11.284%';
  }
  $preloadDymun.animate({right: preloadDymun_right}, {
    duration: animateSpeed1,
    specialEasing: {
      right: "easeOutCubic"
    },
    complete: function() {
      $preloadText.fadeIn(animateSpeed2, 'easeInOutQuad', function() {});
      $preloadAfter.fadeIn(animateSpeed2, 'easeInOutQuad', function() {});
      setTimeout(function() {
        $preloadCalc.fadeIn(animateSpeed2, 'easeInOutQuad', function() {});

        setTimeout(function() {
          
          var numberEnd   = $preloadCalc.data('calc-end');
          var numberStart = $preloadCalc.data('calc-start');
          // var comma_separator_number_step = $.animateNumber.numberStepFactories.separator('');
          $preloadCalcX
            .prop('number', numberStart)
            .animateNumber({

              number: numberEnd,
              numberStep: function(now, tween) {
                var target = $(tween.elem),
                    rounded_now = Math.round(now);

                target.text(now === tween.end ? numberEnd : rounded_now);
              }

              // number: number,
              // numberStep: comma_separator_number_step
            }, animateSpeed1);

        }, animateSpeed2);
        
      }, animateSpeed3);
    }
  });

  var animateSpeed4 = ((faster) ? 2 : 800);
  var animateSpeed5 = ((faster) ? 2 : 700);
  setTimeout(function() {
    $preloadPlus.fadeIn(animateSpeed4, "easeInOutQuad");
    $('.main-preload-logo__center').animate({width: '9.583%'}, {
      duration: animateSpeed4,
      specialEasing: {width: "easeOutCubic"},
      complete: function() {}
    });
  }, animateSpeed5);

  // percent fadeout with delay
  // setTimeout(function() { 
  //   $preloadPercent.fadeIn(400, "easeInOutQuad", function() {});
  //   $preloadPercentX.animateNumber({ number: 100 }, 4500, function() {
  //     afterPreloaderRender(); // events start after plreloader render
  //   });
  // }, 1400);

  var animateSpeed6 = ((faster) ? 2 : 5500);
  setTimeout(function() {
    if (afterpreload) {
      // defaults : faster=false
      afterPreloaderRender();
      // console.log('afterpreload = ' + afterpreload);
    } else {
      // defaults : faster=false
      afterPreloaderRender(true);
    }
  }, animateSpeed6);

}

function afterPreloaderRender(faster=false) {
  // console.log('preloader : rendered');
  $preloadLogoCenter    = $('.main-preload-logo__center');
  $preloadLogoCenterImg = $('.main-preload-logo__center img');
  $preloadLogoNfm       = $('.image-preload__nfm');
  $preloadLogoDymun     = $('.image-preload__dymun');
  // $mainScreenFooter     = $('.main-footer');

  $preVideoTop          = $('.main-prevideo-top');
  $preVideoBottom       = $('.main-prevideo-bottom');

  // top menu background set to white
  $menuTopMain.addClass('_whitebg');

  bottomPlusShow();

  // show main screen footer
  // $mainScreenFooter.addClass('_shown');

  // if (!$('.mobile-page-videobg-main video').hasClass('_start') && $windowWidth <= $breakPointBpMd) {
  //   mainVideobgMobile();
  // }

  $('.main-preload-random-calc').fadeOut(400);
  $('.main-preload-random-text').fadeOut(400);
  $('.main-preload-random-after').fadeOut(400);
  // $('.main-preload-percent').fadeOut(400);
  // mainVideobgStart();

  // animate speed for center logo animations
  // if ($windowWidth > $breakPointBpMd) {
    $preVideoAnimationSpeed = 2000;
  // } else {
  //   $preVideoAnimationSpeed = 10000;
  // }


  if ($windowWidth > $breakPointBpMd) {
    // animation before video show
    $preVideoTop.fadeIn(1000, function() {
      $(this).animate({bottom: '100%'}, {
        duration: $preVideoAnimationSpeed,
        specialEasing: {bottom: "easeOutQuad"},
        complete: function() {}
      });
    });
    // animation before video show
    $preVideoBottom.fadeIn(1000, function() {
      $('.main-videobg').css('z-index', '40');
      $('.main-videobg-image').css('z-index', '1');
      $(this).animate({top: '100%'}, {
        duration: $preVideoAnimationSpeed,
        specialEasing: {top: "easeOutQuad"},
        complete: function() {}
      });
    });
  }

  // fixed top menu handler
  $menuTopMain.animate({top: '0'}, {
    duration: 1000, 
    specialEasing: {top: "easeInOutQuad"},
    complete: function() {
      if (faster) {
        // init fullpage case item
        caseFullpageInit($caseItem, false);
      }

      // run main bg video handler
      
      // after video blur events
      if (!faster) {
        $windowWidth = $(window).width();
        if ($windowWidth > $breakPointBpMd) {
          var timeSpeed = 4000;
        } else {
          var timeSpeed = 300;
        }
        setTimeout(function() { 
          // var videoElement = $('.main-videobg');
          // videoElement.addClass('_blur');
          // var videVideo = videoElement.data('vide').getVideoObject();
          // videVideo.pause();
          // $('.main-content__logo').addClass('_shown');
          $('.main-content__title').addClass('_shown');
          $('.main-content__text').addClass('_shown');
          fullpage_api.setMouseWheelScrolling(true);
          fullpage_api.setAllowScrolling(true);
          $('.main-footer__link').unbind().click(function(e) {
            fullpage_api.moveSectionDown();
          });
        }, timeSpeed);
      }
    }
  });


  // animate speed for center logo animations
  if ($windowWidth > $breakPointBpMd) {
    $preloadLogoAnimationSpeed = 1000;
  } else {
    $preloadLogoAnimationSpeed = 1;
  }


  // preload logo container -> to small
  if ($windowWidth > $breakPointXl) {
    var preloadLogo_width = '285px';
    var preloadLogo_left  = '84.618%';
  } else if ($windowWidth > $breakPointLg && $windowWidth <= $breakPointXl) {
    var preloadLogo_width = '188px';
    var preloadLogo_left  = '84.618%';
  } else if ($windowWidth > $breakPointBpXl && $windowWidth <= $breakPointLg) {
    var preloadLogo_width = '134px';
    var preloadLogo_left  = '84.618%';
  } else if ($windowWidth > $breakPointBpMd && $windowWidth <= $breakPointBpXl) {
    var preloadLogo_width = '97px';
    var preloadLogo_left  = '84.618%';
  } else if ($windowWidth > $breakPointBpSm && $windowWidth <= $breakPointBpMd) {
    var preloadLogo_width = '97px';
    var preloadLogo_left  = '82.618%';
  } else if ($windowWidth <= $breakPointBpSm) {
    var preloadLogo_width = '97px';
    var preloadLogo_left  = ($windowWidth - 112).toString() + 'px';
  }
  $preloadLogo.animate({
    top: '0', 
    height: '10%',
    width: preloadLogo_width,
    left: preloadLogo_left,
    right: '5.590%'
  }, {
    duration: $preloadLogoAnimationSpeed,
    specialEasing: {
      top: "easeInOutQuad",
      height: "easeInOutQuad",
      width: "easeInOutQuad",
      left: "easeInOutQuad",
      right: "easeInOutQuad"
    }
  });

  // preload logo center image -> to small
  if ($windowWidth > $breakPointXl) {
    var preloadLogoCenter_width  = '35px';
    var preloadLogoCenter_height = '35px';
    var preloadLogoCenter_ml     = '-30px';
  } else if ($windowWidth > $breakPointLg && $windowWidth <= $breakPointXl) {
    var preloadLogoCenter_width  = '24px';
    var preloadLogoCenter_height = '24px';
    var preloadLogoCenter_ml     = '-20px';
  } else if ($windowWidth > $breakPointBpXl && $windowWidth <= $breakPointLg) {
    var preloadLogoCenter_width  = '17px';
    var preloadLogoCenter_height = '17px';
    var preloadLogoCenter_ml     = '-13px';
  } else if ($windowWidth <= $breakPointBpXl) {
    var preloadLogoCenter_width  = '13px';
    var preloadLogoCenter_height = '13px';
    var preloadLogoCenter_ml     = '-10px';
  }
  $preloadLogoCenter.animate({
    width: preloadLogoCenter_width,
    height: preloadLogoCenter_height,
    marginLeft: preloadLogoCenter_ml
  }, {
    duration: $preloadLogoAnimationSpeed,
    specialEasing: {width: "easeInOutQuad", height: "easeInOutQuad", marginLeft: 'easeInOutQuad'},
  });

  // preload logo nfm -> to small
  if ($windowWidth > $breakPointXl) {
    var preloadLogoNfm_width  = '83px';
    var preloadLogoNfm_height = '27px';
  } else if ($windowWidth > $breakPointLg && $windowWidth <= $breakPointXl) {
    var preloadLogoNfm_width  = '55px';
    var preloadLogoNfm_height = '18px';
  } else if ($windowWidth > $breakPointBpXl && $windowWidth <= $breakPointLg) {
    var preloadLogoNfm_width  = '40px';
    var preloadLogoNfm_height = '13px';
  } else if ($windowWidth <= $breakPointBpXl) {
    var preloadLogoNfm_width  = '29px';
    var preloadLogoNfm_height = '10px';
  }
  $preloadLogoNfm.animate({
    width:  preloadLogoNfm_width,
    height: preloadLogoNfm_height,
    left:   '0'
  }, {
    duration: $preloadLogoAnimationSpeed, 
    specialEasing: {width: "easeInOutQuad", height: "easeInOutQuad", left: "easeInOutQuad"}
  });

  // preload logo dymun -> to small
  if ($windowWidth > $breakPointXl) {
    var preloadLogoDymun_width  = '145px';
    var preloadLogoDymun_height = '27px';
  } else if ($windowWidth > $breakPointLg && $windowWidth <= $breakPointXl) {
    var preloadLogoDymun_width  = '96px';
    var preloadLogoDymun_height = '18px';
  } else if ($windowWidth > $breakPointBpXl && $windowWidth <= $breakPointLg) {
    var preloadLogoDymun_width  = '69px';
    var preloadLogoDymun_height = '13px';
  } else if ($windowWidth <= $breakPointBpXl) {
    var preloadLogoDymun_width  = '50px';
    var preloadLogoDymun_height = '10px';
  }
  $preloadLogoDymun.animate({
    width:  preloadLogoDymun_width,
    height: preloadLogoDymun_height,
    right:  '0'
  }, {
    duration: $preloadLogoAnimationSpeed, 
    specialEasing: {width: "easeInOutQuad", height: "easeInOutQuad", right: "easeInOutQuad"}
  });
}


function mobileMenuHandler() {
  var mobileMenuOpen  = $('.menu-top-fixed .mobile-menu-open');
  var mobileMenu      = $('#main-mobile-menu');
  var mobileMenuClose = $('#main-mobile-menu .main-mobile-menu-close, #main-mobile-menu ._close');

  mobileMenuOpen.unbind().click(function(event) {
    mobileMenu.animate({left: '0'}, {
      duration: 500,
      specialEasing: {
        left: "easeOutCubic"
      },
      complete: function() {}
    });
  });

  mobileMenuClose.unbind().click(function(event) {
    mobileMenu.animate({left: '-320px'}, {
      duration: 500,
      specialEasing: {
        left: "easeOutCubic"
      },
      complete: function() {}
    });
  });



}

function mobileCaseMenuHandler() {
  var mobileMenuOpen  = $('.menu-top-fixed-lite .mobile-menu-open');
  var mobileMenu      = $('#case-mobile-menu');
  var mobileMenuClose = $('#case-mobile-menu .main-mobile-menu-close');

  mobileMenuOpen.unbind().click(function(event) {
    mobileMenu.animate({left: '0'}, {
      duration: 500,
      specialEasing: {
        left: "easeOutCubic"
      },
      complete: function() {}
    });
  });

  mobileMenuClose.unbind().click(function(event) {
    mobileMenu.animate({left: '-320px'}, {
      duration: 500,
      specialEasing: {
        left: "easeOutCubic"
      },
      complete: function() {}
    });
  });

}

function titleHashHandler(destination, afterload=false) {
  var title = $('.mobile-menu-title-js');

  if (afterload) {
    title.hide();
    title.text(destination.anchor);
    title.show();
  }
  
}


function caseLastScreenScrollHandler(destination) {
  if (destination.isLast) {

    // var caseTextBlock = $(destination.item).find('.mobile-normal-scroll');

    // if (caseTextBlock.length) {
    //   var caseTextBlockMark = $(destination.item).find('.mobile-normal-scroll__mark');
    // }

    $(destination.item).unbind('swipeup').on('swipeup',function(e){

      // if (caseTextBlockMark.length) {

        // var docViewTop = caseTextBlock.offset().top;
        // var docViewBottom = docViewTop + caseTextBlock.height();

        // var elemTop = caseTextBlockMark.offset().top;
        // var elemBottom = elemTop + caseTextBlockMark.height();

        // console.log('docViewTop', docViewTop);
        // console.log('docViewBottom', docViewBottom);
        // console.log('elemTop', elemTop);
        // console.log('elemBottom', elemBottom);

        // console.log();

        // if ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) {
        //   var link = $('#case-contacts-link a').attr('href');
        //   window.location = link;
        //   window.location.reload();
        // }

      // } else {
        var link = $('#case-contacts-link a').attr('href');
        window.location = link;
        window.location.reload();
      // }
      
    });
  }
}


jQuery(document).ready(function($) {

  // dots array
  // x - left | y - top | f - font size
  if ($('.left-menu__item').length) {
    if ($windowWidth > $breakPointXl) {
      $itemsData = [
        { x : '41%',   y : '8.594%',  f : 75  },
        { x : '64%',   y : '27.979%', f : 117 },
        { x : '73.5%', y : '50%',     f : 158 },
        { x : '64%',   y : '72.02%',  f : 117 },
        { x : '41%',   y : '91.45%',  f : 75  },
      ];
    } else if ($windowWidth > $breakPointLg && $windowWidth <= $breakPointXl) {
      $itemsData = [
        { x : '41%',   y : '8.594%',  f : 50  },
        { x : '64%',   y : '27.979%', f : 78  },
        { x : '73.5%', y : '50%',     f : 106 },
        { x : '64%',   y : '72.02%',  f : 78  },
        { x : '41%',   y : '91.45%',  f : 50  },
      ];
    } else if ($windowWidth > $breakPointBpLg && $windowWidth <= $breakPointLg) {
      $itemsData = [
        { x : '41%',   y : '8.594%',  f : 36  },
        { x : '64%',   y : '27.979%', f : 55  },
        { x : '73.5%', y : '50%',     f : 75  },
        { x : '64%',   y : '72.02%',  f : 55  },
        { x : '41%',   y : '91.45%',  f : 36  },
      ];
    } else if ($windowWidth > $breakPointBpSm && $windowWidth <= $breakPointBpLg) {
      $itemsData = [
        { x : '41%',   y : '8.594%',  f : 20  },
        { x : '64%',   y : '27.979%', f : 31  },
        { x : '73.5%', y : '50%',     f : 42  },
        { x : '64%',   y : '72.02%',  f : 31  },
        { x : '41%',   y : '91.45%',  f : 20  },
      ];
    } else if ($windowWidth <= $breakPointBpSm) {
      $itemsData = [
        { x : '41%',   y : '8.594%',  f : 19  },
        { x : '64%',   y : '27.979%', f : 23  },
        { x : '73.5%', y : '50%',     f : 29  },
        { x : '64%',   y : '72.02%',  f : 23  },
        { x : '41%',   y : '91.45%',  f : 19  },
      ];
    }
  }

});



function bottomPlusShow() {
  $bottomPlus.animate({bottom: '0'}, {
    duration: 1000,
    queue: false,
    specialEasing: {
      bottom: "easeOutCubic"
    },
    complete: function() {}
  });
}

function bottomPlusHide() {
  $bottomPlus.animate({bottom: '-10%'}, {
    duration: 1000,
    queue: false,
    specialEasing: {
      bottom: "easeOutCubic"
    },
    complete: function() {}
  });
}

function leftMenuSetActiveItem() {
  $('.left-menu__item').each(function(index, el) {
    $(this).removeClass('active');
    if (parseInt($(this).attr('data-position')) == 2) {
      $(this).addClass('active');
      var dataPage = $(this).attr('data-page');
      var plusLink = $('.case-section__link a');
      plusLink.attr('data-page', dataPage);
    }
  });
}


function leftMenuShow() {
  // $leftMenu - defined in common.js
  console.log('leftMenu : shown');

  $leftMenuItem = $('.left-menu__item');

  // dots array
  // x - left | y - top | f - font size
  if ($windowWidth > $breakPointXl) {
    $itemsData = [
      { x : '41%',   y : '8.594%',  f : 75  },
      { x : '64%',   y : '27.979%', f : 117 },
      { x : '73.5%', y : '50%',     f : 158 },
      { x : '64%',   y : '72.02%',  f : 117 },
      { x : '41%',   y : '91.45%',  f : 75  },
    ];
  } else if ($windowWidth > $breakPointLg && $windowWidth <= $breakPointXl) {
    $itemsData = [
      { x : '41%',   y : '8.594%',  f : 50  },
      { x : '64%',   y : '27.979%', f : 78  },
      { x : '73.5%', y : '50%',     f : 106 },
      { x : '64%',   y : '72.02%',  f : 78  },
      { x : '41%',   y : '91.45%',  f : 50  },
    ];
  } else if ($windowWidth > $breakPointBpLg && $windowWidth <= $breakPointLg) {
    $itemsData = [
      { x : '41%',   y : '8.594%',  f : 36  },
      { x : '64%',   y : '27.979%', f : 55  },
      { x : '73.5%', y : '50%',     f : 75  },
      { x : '64%',   y : '72.02%',  f : 55  },
      { x : '41%',   y : '91.45%',  f : 36  },
    ];
  } else if ($windowWidth > $breakPointBpSm && $windowWidth <= $breakPointBpLg) {
    $itemsData = [
      { x : '41%',   y : '8.594%',  f : 20  },
      { x : '64%',   y : '27.979%', f : 31  },
      { x : '73.5%', y : '50%',     f : 42  },
      { x : '64%',   y : '72.02%',  f : 31  },
      { x : '41%',   y : '91.45%',  f : 20  },
    ];
  } else if ($windowWidth <= $breakPointBpSm) {
    $itemsData = [
      { x : '41%',   y : '8.594%',  f : 19  },
      { x : '64%',   y : '27.979%', f : 21  },
      { x : '73.5%', y : '50%',     f : 22  },
      { x : '64%',   y : '72.02%',  f : 21  },
      { x : '41%',   y : '91.45%',  f : 19  },
    ];
  }

  // menu appear
  $leftMenu.addClass('active');
  $leftMenu.fadeIn(1000, function() {});
  $leftMenu.animate({left: '0'}, {
    duration: 1000,
    queue: false,
    specialEasing: {
      left: "easeOutCubic"
    },
    complete: function() {
      caseLinkButtonHandler();
      $leftMenuItem.click(function(event) {
        var sectionLink = $(this).attr('data-link-name');
        fullpage_api.moveTo(sectionLink);
      });



      $('.left-menu__item').unbind('swipedown').on('swipedown',function(){
        fullpage_api.moveSectionUp();
        console.log('moveSectionUp');
      });
      $('.left-menu__item').unbind('swipeup').on('swipeup',function(){
        fullpage_api.moveSectionDown();
        console.log('moveSectionDown');
      });
    }
  });

}


function leftMenuHide() {
  // $leftMenu - defined in common.js
  console.log('leftMenu : hide');

  if ($windowWidth > $breakPointXl) {
    var leftMenuLeft = '-200';
  } else if ($windowWidth > $breakPointLg && $windowWidth <= $breakPointXl) {
    var leftMenuLeft = '-132';
  } else if ($windowWidth > $breakPointBpLg && $windowWidth <= $breakPointLg) {
    var leftMenuLeft = '-95';
  } else if ($windowWidth <= $breakPointBpLg) {
    var leftMenuLeft = '-53';
  }
  $leftMenu.removeClass('active');
  $leftMenu.fadeOut(300, function() {});
  $leftMenu.animate({left: leftMenuLeft}, {
    duration: 300,
    queue: false,
    specialEasing: {
      left: "easeOutCubic"
    },
    complete: function() {
      if (typeof $leftMenuItem !== 'undefined') {
        $leftMenuItem.unbind();
      }
    }
  });
}


// MAIN MENU SCROLL HANDLER
function leftMenuScrollHandler(direction) {
  // scroll down handler
  if (direction == 'down') {
    $(".left-menu__item._visible").each( function( index, element ){
      var positionCurrent = $(this).attr('data-position');
      var positionNext = parseInt(positionCurrent) - 1;

      if (positionNext == -1) {
        $(this).fadeOut(400).addClass('_hidden').removeClass('_visible');
      } 
      else {
        $(this).attr('data-position', positionNext);
        var animateTop  = $itemsData[positionNext].y;
        var animateLeft = $itemsData[positionNext].x;
        var animateFont = $itemsData[positionNext].f;

        $(this).animate({
            top: animateTop,
            left: animateLeft,
            fontSize: animateFont,
          }, {
          duration: 700,
          queue: false,
          specialEasing: {
            top: "easeOutCubic", left: "easeOutCubic", fontSize: "easeOutCubic",
          },
          complete: function() {
            // leftMenuClickHandler();
          }
        });
      }

      var nextItem = $(this).next();
      if (nextItem.hasClass('_hidden')) {
        nextItem.fadeIn(400).removeClass('_hidden').addClass('_visible');
      }
    });
  }
  // scroll up handler
  if (direction == 'up') {
    $(".left-menu__item._visible").each( function( index, element ){
      var positionCurrent = $(this).attr('data-position');
      var positionNext = parseInt(positionCurrent) + 1;

      if (positionNext == 5) {
        $(this).fadeOut(400).addClass('_hidden').removeClass('_visible');
      }
      else {
        $(this).attr('data-position', positionNext);
        var animateTop  = $itemsData[positionNext].y;
        var animateLeft = $itemsData[positionNext].x;
        var animateFont = $itemsData[positionNext].f;
        
        $(this).animate({
            top: animateTop,
            left: animateLeft,
            fontSize: animateFont,
          }, {
          duration: 700,
          queue: false,
          specialEasing: {
            top: "easeOutCubic", left: "easeOutCubic", fontSize: "easeOutCubic",
          },
          complete: function() {
            // leftMenuClickHandler();
          }
        });
      }

      var nextItem = $(this).prev();
      if (nextItem.hasClass('_hidden')) {
        nextItem.fadeIn(400).removeClass('_hidden').addClass('_visible');
      }
    });
  }
}


// main menu custom steps function
function leftMenuStepsMove(stepUp=0, stepDown=0) {
  if (stepUp > 0) {
    while (stepUp > 0) {
      leftMenuScrollHandler('up');
      stepUp--;
    }
  }
  if (stepDown > 0) {
    while (stepDown > 0) {
      leftMenuScrollHandler('down');
      stepDown--;
    }
  }
}



jQuery(document).ready(function($) {

  

  returnToMainHandler();
  

  
});

// back to main fullpage button handler
function returnToMainHandler() {
  $('.case-menu-fixed__close').unbind().click(function(event) {
    $('#preloader').fadeIn(400, function() {
      fullpage_api.destroy('all');
      $('#case-contacts-link').animate({bottom: -200}, {
        duration: 300,
        queue: false,
        specialEasing: {
          bottom: "easeOutCubic"
        },
        complete: function() {}
      });
      $('.fullpage-case').removeClass('active');
      $('#fullpage-main').css('display', '');
      $('.case-menu-fixed').removeClass('active');
      $('.left-menu__item.active').css('display', '').removeClass('_menu-clicked');
      mainMenusRegenerate();

      // footer regenerate handler
      bottomPlusShow();
      var bottomPlusId = $('#bottom-plus');
      $('.main-footer__link').fadeOut(300, function() {
        $('.main-footer__link').removeClass('active');
        if (bottomPlusId.hasClass('_about-linked')) {
          $('.about-us-link').fadeIn(300, function() {});
          $('.fullpage-link._plus').fadeOut(300, function() {});
        } else {
          $('.about-us-link').fadeOut(300, function() {});
          $('.fullpage-link._plus').fadeIn(300, function() {});
        }
      });

      // hash regenerate
      if (window.location.hash != 'main') {
        window.location.hash = 'main';
      }
      mainFullpageInit(false);
      fullpage_api.reBuild();
    });
  });
}


function caseLinkButtonHandler() {
  $caseLinkButton = $('.fullpage-link');
  $caseLinkButton.unbind().click(function(event) {
    if ($(this).hasClass('active') && $(this).attr('data-page') != '#') {
      var caseItem = $(this).attr('data-page');
      
      if ($windowWidth < $breakPointBpSm) {
        $('#preloader').fadeIn(300, function() {
          $('#preloader').addClass('active');
          mainMenusHide(caseItem);
        });
      } else {
        mainMenusHide(caseItem);
      }
      
    }
  });
}

function mainMenusHide(caseItem) {

  // reset main page videos status
  $('.page-videobg').removeClass('start');
  $('.main-videobg').removeClass('start');

  console.log('caseItem = ' + caseItem);

  // case fixed header data fill
  caseHeaderDataHandle(caseItem);
  // hide bottom plus
  bottomPlusHide();
  // hide top menu
  $menuTopMain.animate({top : '-10%'}, {
    duration: 700,
    specialEasing: {
      top: "easeOutCubic"
    },
    complete: function() {
      $('#' + caseItem).addClass('active');
      $('#fullpage-main').css('display', 'none');
      caseFullpageInit(caseItem);
      fullpage_api.reBuild();
    }
  });
  // hide fixed logo NFM
  $preloadLogo.animate({top : '-10%'}, {
    duration: 700,
    specialEasing: {
      top: "easeOutCubic"
    },
    complete: function() {}
  });
  // hide bottom plus button
  var caseLinkPlusButton = $('.fp-section.active .case-section__link');
  caseLinkPlusButton.animate({bottom : '-10%'}, {
    duration: 700,
    specialEasing: {
      bottom: "easeOutCubic"
    },
    complete: function() {}
  });
  // push section link name to screen center
  if ($windowWidth > $breakPointXl) {
    var itemPadding  = 60;
  } else if ($windowWidth > $breakPointLg && $windowWidth <= $breakPointXl) {
    var itemPadding  = 45;
  } else if ($windowWidth <= $breakPointLg) {
    var itemPadding  = 30;
  }
  var currentSectionName = $('.left-menu__item.active');
  var currentSectionLeft = $(window).width() / 2 - currentSectionName.width() / 2;
  currentSectionName.addClass('_menu-clicked');
  currentSectionName.animate({left : currentSectionLeft}, {
    duration: 700,
    specialEasing: {
      left: "easeOutCubic"
    },
    complete: function() {}
  });
  // hide other menu items
  $('.left-menu__item').each(function(index, el) {
    if (!$(this).hasClass('active')) {
      $(this).animate({left : '-1000%'}, {
        duration: 2000,
        specialEasing: {
          left: "easeOutCubic"
        },
        complete: function() {}
      });
    }
  });
  // hide menu bg image
  $('#left-menu').animate({backgroundPositionX : '-100%'}, {
    duration: 100,
    specialEasing: {
      backgroundPositionX: "easeOutCubic"
    },
    complete: function() {}
  });
}


function mainMenusRegenerate() {
  // hide single section navigation
  $('.fullpage-case-single-menu').removeClass('active');
  // return top menu
  $menuTopMain.animate({top : '0'}, {
    duration: 0,
    specialEasing: {
      top: "easeOutCubic"
    },
    complete: function() {}
  });
  // return fixed logo NFM
  $preloadLogo.animate({top : '0'}, {
    duration: 0,
    specialEasing: {
      top: "easeOutCubic"
    },
    complete: function() {}
  });
  // return menu bg image position
  $('#left-menu').animate({backgroundPositionX : '0'}, {
    duration: 0,
    specialEasing: {
      left: "easeOutCubic"
    },
    complete: function() {}
  });

  // regenerate menu items positions
  $(".left-menu__item").each( function( index, element ){
    var positionCurrent = $(this).attr('data-position');
    if (positionCurrent == -1) {
      var animateTop  = $itemsData[0].y;
      var animateLeft = $itemsData[0].x;
      var animateFont = $itemsData[0].f;
    } else if (positionCurrent == 5) {
      var animateTop  = $itemsData[4].y;
      var animateLeft = $itemsData[4].x;
      var animateFont = $itemsData[4].f;
    } else {
      var animateTop  = $itemsData[positionCurrent].y;
      var animateLeft = $itemsData[positionCurrent].x;
      var animateFont = $itemsData[positionCurrent].f;
    }
    $(this).animate({
        top: animateTop,
        left: animateLeft,
        fontSize: animateFont,
      }, {
      duration: 100,
      queue: false,
      specialEasing: {
        top: "easeOutCubic", left: "easeOutCubic", fontSize: "easeOutCubic",
      },
      complete: function() {}
    });
  });
}


function caseHeaderDataHandle(caseItem) {
  var caseTitle = $('.case-menu-fixed .text-title');
  var caseText  = $('.case-menu-fixed .description');

  var caseTitleToSet = $('#' + caseItem).attr('data-case-title');
  var caseTextToSet  = $('#' + caseItem).attr('data-case-text');

  caseTitle.text(caseTitleToSet);
  caseText.text(caseTextToSet);
}




jQuery(document).ready(function($) {

});

function aboutLogosFlipMain() {
  var flipContainers = $('.about-partners__logo-container .flip-container');

  // var testData = test.data('images');

  $flipStopper       = false;

  $flipCounter       = 0;
  $flipSmallNoRepeat = 999;
  $flipBigNoRepeat   = 999;

  setInterval(function(){

    if ( $flipStopper == false ) {

      if ( $flipCounter >= 3 ) {
        $flipCounter = 0;

        var random1 = Math.floor(Math.random() * (7 - 5) + 5);
        if (random1 == $flipBigNoRepeat) {while (random1 == $flipBigNoRepeat) {
          random1 = Math.floor(Math.random() * (7 - 5) + 5);
        }}

        $flipBigNoRepeat = random1;

        var flip1 = flipContainers.eq(random1);
        // console.log('random BIG item to flip = ' + random1);
        logosFlipHandler(flip1);

      } else {

        var random1 = Math.floor(Math.random() * flipContainers.length);
        if (random1 == $flipSmallNoRepeat || random1 == 5 || random1 == 6) {while (random1 == $flipSmallNoRepeat || random1 == 5 || random1 == 6) {
          random1 = Math.floor(Math.random() * flipContainers.length);
        }}

        $flipSmallNoRepeat = random1;

        var flip1 = flipContainers.eq(random1);
        // console.log('random SMALL item to flip = ' + random1);
        logosFlipHandler(flip1);

      }

    }
    
  }, 500);
}


function logosFlipHandler(fliper) {
  var fliperImages = fliper.data('images');
  var fliperFront  = fliper.find('.front-logo');
  var fliperBack   = fliper.find('.back-logo');
  if (fliper.hasClass('_large')) {
    var fliperBgrs    = fliper.data('bgrs');
    var fliperFrontBg = fliper.find('.front-bg');
    var fliperBackBg  = fliper.find('.back-bg');
  }
  // console.log(fliperImages);
  // console.log(fliperImages.length);

  if (!fliper.hasClass('hover')) {

    var currentIndex = parseInt(fliperFront.attr('data-index'));
    var randomImage  = Math.floor(Math.random() * fliperImages.length);

    // console.log(randomImage);

    if (currentIndex == randomImage && fliperImages.length > 1) {while (currentIndex == randomImage) {
      var randomImage  = Math.floor(Math.random() * fliperImages.length);
    }}

    fliperBack.attr('data-index', randomImage);
    fliperBack.css('background-image', 'url(' + fliperImages[randomImage] + ')');
    if (fliper.hasClass('_large')) {
      fliperBackBg.attr('src', fliperBgrs[randomImage]);
    }

    $flipStopper = true;
    setTimeout(function(){
      fliper.addClass('hover');
      $flipStopper = false;
    }, 1000);

  } else {

    var currentIndex = parseInt(fliperBack.attr('data-index'));
    var randomImage  = Math.floor(Math.random() * fliperImages.length);

    if (currentIndex == randomImage && fliperImages.length > 1) {while (currentIndex == randomImage) {
      var randomImage  = Math.floor(Math.random() * fliperImages.length);
    }}

    fliperFront.attr('data-index', randomImage);
    fliperFront.css('background-image', 'url(' + fliperImages[randomImage] + ')');
    if (fliper.hasClass('_large')) {
      fliperFrontBg.attr('src', fliperBgrs[randomImage]);
    }

    $flipStopper = true;
    setTimeout(function(){
      fliper.removeClass('hover');
      $flipStopper = false;
    }, 1000);

  }

  $flipCounter++;
}



function aboutLogosFlipMobile() {
  var flipContainers = $('#mobile-partners-logo .mobile-circleswap .flip-container');

  // var testData = test.data('images');

  $flipCounter       = 0;
  $flipSmallNoRepeat = 999;
  $flipBigNoRepeat   = 999;

  setInterval(function(){

    if ($flipCounter >= 3) {
      $flipCounter = 0;

      var random1 = Math.floor(Math.random() * (7 - 5) + 5);
      if (random1 == $flipBigNoRepeat) {while (random1 == $flipBigNoRepeat) {
        random1 = Math.floor(Math.random() * (7 - 5) + 5);
      }}

      $flipBigNoRepeat = random1;

      var flip1 = flipContainers.eq(random1);
      // console.log('random BIG item to flip = ' + random1);
      logosFlipHandler(flip1);

    } else {

      var random1 = Math.floor(Math.random() * flipContainers.length);
      if (random1 == $flipSmallNoRepeat || random1 == 5 || random1 == 6) {while (random1 == $flipSmallNoRepeat || random1 == 5 || random1 == 6) {
        random1 = Math.floor(Math.random() * flipContainers.length);
      }}

      $flipSmallNoRepeat = random1;

      var flip1 = flipContainers.eq(random1);
      // console.log('random SMALL item to flip = ' + random1);
      logosFlipHandler(flip1);

    }
    


    // var random2 = Math.floor(Math.random() * flipContainers.length);

    // if (random1 == random2) { while (random1 == random2) {
    //   random2 = Math.floor(Math.random() * flipContainers.length);
    // }}

    
    // var flip2 = flipContainers.eq(random2);

    // console.log(random1 + ' <==> ' + random2);
    
    // logosFlipHandler(flip2);

  }, 1500);
}









jQuery(document).ready(function($) {

  $("#mobile-people-swipe .mobile-circleswapjs .swipe-container:last-child").addClass('_last');

  peopleFlipperInit();

  $mobileHeightBPFirst = 890;
  $mobileHeightBPSecond = 640;
  $mobileHeightBPThird = 560;

  $swipeMobileSpeed = 500;

  $windowHeight = $(window).height();

  if ($windowHeight > $mobileHeightBPFirst) {
    $swiperContainerLarge = '285px';
    $swiperContainerSmall = '135px';
    $swiperImageLarge = '420px';
    $swiperImageSmall = '210px';
    $swiperImageLargeXY = '-65px';
    $swiperMobileData = [
      { top : '136px', left : '150px' },
      { top : '0px',   left : '120px' },
      { top : '107px', left : '13px'  },
      { top : '317px', left : '13px'  },
      { top : '423px', left : '119px' },
      { top : '529px', left : '226px' },
      { top : '423px', left : '333px' },
    ];
  } else if ($windowHeight > $mobileHeightBPSecond && $windowHeight <= $mobileHeightBPFirst) {
    $swiperContainerLarge = '209px';
    $swiperContainerSmall = '100px';
    $swiperImageLarge = '300px';
    $swiperImageSmall = '140px';
    $swiperImageLargeXY = '-40px';
    $swiperMobileData = [
      { top : '101px', left : '103px' },
      { top : '0px',   left : '80px'  },
      { top : '78px',  left : '2px'   },
      { top : '234px', left : '2px'   },
      { top : '312px', left : '80px'  },
      { top : '389px', left : '158px' },
      { top : '312px', left : '237px' },
    ];
  } else if ($windowHeight > $mobileHeightBPThird && $windowHeight <= $mobileHeightBPSecond) {
    $swiperContainerLarge = '170px';
    $swiperContainerSmall = '80px';
    $swiperImageLarge = '250px';
    $swiperImageSmall = '110px';
    $swiperImageLargeXY = '-35px';
    $swiperMobileData = [
      { top : '82px',  left : '81px'  },
      { top : '0px',   left : '65px'  },
      { top : '64px',  left : '2px'   },
      { top : '190px', left : '2px'   },
      { top : '254px', left : '64px'  },
      { top : '317px', left : '129px' },
      { top : '253px', left : '192px' },
    ];
  } else if ($windowHeight <= $mobileHeightBPThird) {
    $swiperContainerLarge = '148px';
    $swiperContainerSmall = '70px';
    $swiperImageLarge = '210px';
    $swiperImageSmall = '100px';
    $swiperImageLargeXY = '-35px';
    $swiperMobileData = [
      { top : '71px',  left : '74px'  },
      { top : '0px',   left : '58px'  },
      { top : '56px',  left : '2px'   },
      { top : '165px', left : '2px'   },
      { top : '221px', left : '58px'  },
      { top : '277px', left : '113px' },
      { top : '222px', left : '168px' },
    ];
  }
  
  $swipeBusy = false;

  // setup position of hidden elements
  var peopleItemHidden = $("#mobile-people-swipe .mobile-circleswapjs .swipe-container._hidden");
  peopleItemHidden.each(function(index, element) {
    $(this).css({
      top:  $swiperMobileData[6].top,
      left: $swiperMobileData[6].left
    });
  });

  // setup position of visible elements
  var peopleItemVisible = $("#mobile-people-swipe .mobile-circleswapjs .swipe-container._visible");
  peopleItemVisible.each(function(index, element) {
    $(this).css({
      top:  $swiperMobileData[index].top,
      left: $swiperMobileData[index].left
    });
  });

  // hide "tap me" on click
  $("#mobile-people-swipe").click(function(event) {
    // tapMeHandler('click');
  });

  // SWIPE LEFT HANDLER
  $("#mobile-people-swipe").on('swipeleft', function(){ 
    console.log('swipeleft - swipeBusy', $swipeBusy);
    if (!$swipeBusy) {
      $swipeBusy = true;

      console.log('swipeleft');

      // hide "tap me" on swipe
      tapMeHandler('swipe');

      // hide center tab if its active
      var centerTab     = $('#mobile-circleswapjs-center');
      var centerTabItem = $('#mobile-circleswapjs-center .swipe-container');
      if (centerTab.hasClass('_active')) {
        centerTab.removeClass('_active');
        centerTabItem.fadeOut(300, function() {
          centerTab.css('z-index', '');
        });
      }

      var finger = $('#mobile-circleswapjs-finger');
      if (finger.hasClass('_visible')) {
        finger.fadeOut(300, function() {
          $(this).removeClass('_visible');
        });
      }

      var peopleItem = $("#mobile-people-swipe .mobile-circleswapjs .swipe-container._visible");

      peopleItem.each(function( index, element){
        var positionCurrent = $(this).attr('data-position');
        var positionNext = parseInt(positionCurrent) - 1;

        if (positionNext == -1) {
          $(this).fadeOut(400, function() {
            // $(this).addClass('_hidden').removeClass('_visible').removeClass('_large').removeClass('_transition');
            $(this).attr('class', 'swipe-container _hidden _overflow-visible');
          });
        } 
        else {
          $(this).attr('data-position', positionNext);
          var animateTop  = $swiperMobileData[positionNext].top;
          var animateLeft = $swiperMobileData[positionNext].left;

          if (positionNext == 0) {
            var flipper   = $(this).find('.flipper');
            var front     = $(this).find('.front');
            var frontWrap = $(this).find('.front-wrapper');
            var back      = $(this).find('.back');
            var backWrap  = $(this).find('.back-wrapper');
            var images    = $(this).find('img');
            console.log('swipeleft - start animation');
            $(this).animate({
                top: animateTop,
                left: animateLeft,
                width: $swiperContainerLarge,
                height: $swiperContainerLarge,
              }, {
              duration: $swipeMobileSpeed,
              queue: false,
              specialEasing: {
                top: "easeOutCubic", left: "easeOutCubic", width: "easeOutCubic", height: "easeOutCubic",
              },
              complete: function() {
                if (!$(this).hasClass('_large')) {
                  $(this).addClass('_large');
                }
                $(this).addClass('_transition');
                $(this).unbind('click').click(function(event) {
                  $(this).toggleClass('hover');
                  tapMeHandler('click');
                });

                setTimeout(function(){
                  $swipeBusy = false; // unlock animation
                  console.log('swipeleft - end animation');
                }, 300);
              }
            });
            front.add(back).add(frontWrap).add(backWrap).add(flipper).animate({ width: $swiperContainerLarge, height: $swiperContainerLarge, }, {
              duration: $swipeMobileSpeed,
              queue: false,
              specialEasing: {
                width: "easeOutCubic", height: "easeOutCubic",
              },
              complete: function() {}
            });
            images.animate({ width: $swiperImageLarge, /* top: $swiperImageLargeXY, left: $swiperImageLargeXY */ }, {
              duration: $swipeMobileSpeed,
              queue: false,
              specialEasing: {
                width: "easeOutCubic", top: "easeOutCubic", left: "easeOutCubic",
              },
              complete: function() {}
            });

          } else {
            $(this).animate({
                top: animateTop,
                left: animateLeft,
              }, {
              duration: $swipeMobileSpeed,
              queue: false,
              specialEasing: {
                top: "easeOutCubic", left: "easeOutCubic",
              },
              complete: function() {
                // leftMenuClickHandler();
              }
            });
          }
        }

        var nextItem = $(this).next();
        if (nextItem.hasClass('_hidden')) {
          if (nextItem.hasClass('_last')) {
            nextItem.fadeIn($swipeMobileSpeed).removeClass('_hidden').removeClass('_last').addClass('_visible');
            nextItem.attr('data-position', '6');

            var firstChild = $("#mobile-people-swipe .mobile-circleswapjs .swipe-container:first-child");
            firstChild.unbind('click').appendTo('#mobile-people-swipe .mobile-circleswapjs').addClass('_last').css({
              top:    $swiperMobileData[6].top,
              left:   $swiperMobileData[6].left,
              width:  '',
              height: '',
            });

            var flipper   = firstChild.find('.flipper');
            var front     = firstChild.find('.front');
            var frontWrap = firstChild.find('.front-wrapper');
            var back      = firstChild.find('.back');
            var backWrap  = firstChild.find('.back-wrapper');
            var images    = firstChild.find('img');
            front.add(back).add(frontWrap).add(backWrap).add(flipper).css({
              width:  '',
              height: ''
            });
            images.css({
              width: '',
              top:   '',
              left:  ''
            });

            peopleFlipperInit();

          } else {
            nextItem.fadeIn(300).removeClass('_hidden').addClass('_visible');
          }
        }
      });

    }

  });


  // SWIPE RIGHT HANDLER
  $("#mobile-people-swipe").on('swiperight', function(){ 
    console.log('swiperight - swipeBusy', $swipeBusy);

    if (!$swipeBusy) {
      $swipeBusy = true;
      console.log('swiperight');

      // hide "tap me" on swipe
      tapMeHandler('swipe');

      // hide center tab if its active
      var centerTab     = $('#mobile-circleswapjs-center');
      var centerTabItem = $('#mobile-circleswapjs-center .swipe-container');
      if (centerTab.hasClass('_active')) {
        var largeHiddenItem = $("#mobile-people-swipe .mobile-circleswapjs .swipe-container._large");
        largeHiddenItem.css('display', '');

        centerTab.removeClass('_active');
        centerTabItem.fadeOut(300, function() {
          centerTab.css('z-index', '');
        });
      }

      var finger = $('#mobile-circleswapjs-finger');
      if (finger.hasClass('_visible')) {
        finger.fadeOut(300, function() {
          $(this).removeClass('_visible');
        });
      }

      var peopleItem = $("#mobile-people-swipe .mobile-circleswapjs .swipe-container._visible");

      peopleItem.each(function(index, element){
        var positionCurrent = $(this).attr('data-position');
        var positionNext = parseInt(positionCurrent) + 1;

        if (positionNext == 7) {
          $(this).fadeOut(400, function() {
            $(this).attr('class', 'swipe-container _hidden _overflow-visible');
          });
        } 
        else {
          $(this).attr('data-position', positionNext);

          var animateTop  = $swiperMobileData[positionNext].top;
          var animateLeft = $swiperMobileData[positionNext].left;

          // console.log("rule", positionCurrent == 0 && $(this).hasClass('_large'));

          // if (positionCurrent == 0 && $(this).hasClass('_large')) {
          if ($(this).hasClass('_large')) {

            if ($(this).hasClass('hover')) {
              $(this).removeClass('hover');
            }

            // handle next item
            var nextDataPosition = $(this).prev().attr('data-position');

            if (nextDataPosition == "0") {
              var prevItem = $(this).prev();

              prevItem.attr('data-position', '0').addClass('_large')

              prevItem.fadeIn(500, function() {
                $(this).removeClass('_hidden').addClass('_visible');
              });

            } else {
              // console.log('_large2');
              var nextItem       = $('#mobile-people-swipe .mobile-circleswapjs .swipe-container._last');
              var beforeNextItem = nextItem.prev();

              beforeNextItem.addClass('_last');

              var nextFlipper   = nextItem.find('.flipper');
              var nextFront     = nextItem.find('.front');
              var nextFrontWrap = nextItem.find('.front-wrapper');
              var nextBack      = nextItem.find('.back');
              var nextBackWrap  = nextItem.find('.back-wrapper');
              var nextImages    = nextItem.find('img');
              nextFront.add(nextBack).add(nextFrontWrap).add(nextBackWrap).add(nextFlipper).css({
                width:  '',
                height: ''
              });
              nextImages.css({
                width: '',
                top:   '',
                left:  ''
              });

              nextItem.addClass('_large').addClass('_transition').css({
                top:  $swiperMobileData[0].top,
                left: $swiperMobileData[0].left,
                width:  '',
                height: '',
              }).prependTo('#mobile-people-swipe .mobile-circleswapjs').attr('data-position', '0');

              setTimeout(function(){
                nextItem.fadeIn(300, function() {
                  nextItem.removeClass('_hidden').removeClass('_last').addClass('_visible');
                });
              }, 200);
            }

            console.log('swiperight - start animation');
            

            var flipper   = $(this).find('.flipper');
            var front     = $(this).find('.front');
            var frontWrap = $(this).find('.front-wrapper');
            var back      = $(this).find('.back');
            var backWrap  = $(this).find('.back-wrapper');
            var images    = $(this).find('img');
            $(this).animate({
                top: animateTop,
                left: animateLeft,
                width: $swiperContainerSmall,
                height: $swiperContainerSmall,
              }, {
              duration: $swipeMobileSpeed,
              queue: false,
              specialEasing: {
                top: "easeOutCubic", left: "easeOutCubic", width: "easeOutCubic", height: "easeOutCubic",
              },
              complete: function() {
                $(this).addClass('_transition');
                peopleFlipperInit();
                $(this).removeClass('_large').removeClass('_last').removeClass('_transition').removeClass('hover');
                setTimeout(function(){
                  $swipeBusy = false;
                  console.log('swiperight - end animation');
                }, 300);
              }
            });
            front.add(back).add(frontWrap).add(backWrap).add(flipper).animate({ width: $swiperContainerSmall, height: $swiperContainerSmall, }, {
              duration: $swipeMobileSpeed,
              queue: false,
              specialEasing: {
                width: "easeOutCubic", height: "easeOutCubic",
              },
              complete: function() {}
            });
            images.animate({ width: $swiperImageSmall, }, {
              duration: $swipeMobileSpeed,
              queue: false,
              specialEasing: {
                width: "easeOutCubic", top: "easeOutCubic", left: "easeOutCubic",
              },
              complete: function() {}
            });

          } else {
            $(this).animate({
                top: animateTop,
                left: animateLeft,
              }, {
              duration: $swipeMobileSpeed,
              queue: false,
              specialEasing: {
                top: "easeOutCubic", left: "easeOutCubic",
              },
              complete: function() {
                // console.log('index', index);
                // if (index === 5) {
                  
                // }
              }
            });
          }
        }

      });

    } /* $swipeBusy if */


  });

});


function tapMeHandler(event) {
  var tapme = $('#mobile-circleswapjs-tapme-finger');
  if (event == 'click' && !tapme.hasClass('_kill')) {
    tapme.removeClass('_visible').addClass('_kill');
  } else if (event == 'swipe' && !tapme.hasClass('_kill')) {
    tapme.addClass('_visible');
  }

}

function peopleFlipperInit() {
  // console.log('peopleFlipperInit : FIRE');
  var peopleFlipper = $("#mobile-people-swipe .mobile-circleswapjs .swipe-container");
  peopleFlipper.unbind().click(function(event) {

    tapMeHandler('click');

    if (!$swipeBusy) {
      $swipeBusy = true;
      console.log('peopleFlipper CLICK');

      // if ($(this).hasClass('_transition')) {
      if ($(this).hasClass('_large')) {
        console.log('peopleFlipper CLICK - hover');
        if (!$(this).hasClass('_transition')) {
          $(this).addClass('_transition');
        }
        $(this).toggleClass('hover');
        setTimeout(function(){
          $swipeBusy = false;
        }, 200);
      }

      // if ($(this).hasClass('_visible') && !$(this).hasClass('_transition')) {
      if ($(this).hasClass('_visible') && !$(this).hasClass('_large')) {
        console.log('peopleFlipper CLICK - mobileSwiperTabsHandler');
        mobileSwiperTabsHandler($(this));
      }

    }
  });
}


function mobileSwiperTabsHandler(clickedTab) {
  var frontImageToSet  = clickedTab.find('.front-wrapper').find('img').attr('src');
  var backImageToSet   = clickedTab.find('.back-wrapper').find('img').attr('src');
  var backTextName     = clickedTab.find('.back-text__name').text();
  var backTextPosition = clickedTab.find('.back-text__position').text();
  // capabilities texts to set
  var frontTextToSet   = clickedTab.find('.front-text').text();
  var backTextToSet    = clickedTab.find('.back-centered-text').text();

  var centerTab              = $('#mobile-circleswapjs-center');
  var centerTabItem          = $('#mobile-circleswapjs-center .swipe-container');
  var centerTabFrontImg      = centerTab.find('.front-wrapper').find('img');
  var centerTabBackImg       = centerTab.find('.back-wrapper').find('img');
  var centerTabBackName      = centerTab.find('.back-text__name');
  var centerTabBackPosition  = centerTab.find('.back-text__position');
  // capabilities text elements to fill
  var centerTabFrontText     = centerTab.find('.front-text')
  var centerTabBackText      = centerTab.find('.back-centered-text')

  centerTabItem.removeClass('hover');

  if (centerTab.hasClass('_active')) {
    centerTabItem.fadeOut(300, function() {
      centerTabFrontImg.attr('src', frontImageToSet);
      centerTabBackImg.attr('src', backImageToSet);
      centerTabBackName.text(backTextName);
      centerTabBackPosition.text(backTextPosition);

      // capabilities texts setter
      centerTabFrontText.text(frontTextToSet);
      centerTabBackText.text(backTextToSet);

      $(this).fadeIn(300, function() {
        setTimeout(function(){
          $swipeBusy = false;
          console.log('mobileSwiperTabsHandler - center.active - end');
        }, 200);
      });
    });
  } 
  else {
    centerTabFrontImg.attr('src', frontImageToSet);
    centerTabBackImg.attr('src', backImageToSet);
    centerTabBackName.text(backTextName);
    centerTabBackPosition.text(backTextPosition);

    // capabilities texts setter
    centerTabFrontText.text(frontTextToSet);
    centerTabBackText.text(backTextToSet);

    // var activeItem = $('#mobile-people-swipe .mobile-circleswapjs .swipe-container._visible._transition');
    var activeItem = $('#mobile-people-swipe .mobile-circleswapjs .swipe-container._visible._large');

    activeItem.fadeOut(300, function() {
      centerTabItem.fadeIn(300, function() {
        centerTab.addClass('_active').css('z-index', '10');
        $(this).unbind('click').click(function(event) {
          $(this).toggleClass('hover');
        });
        setTimeout(function(){
          $swipeBusy = false;
          console.log('mobileSwiperTabsHandler - center.passive - end');
        }, 200);
      });
    });
  }

  


}
